import { useQuery } from 'react-query';
import { useAPI } from '@axo/shared/data-access/provider';
import { ace_api } from '@axo/shared/data-access/api';
import { queryFunction } from '../../query-function';
import { bucketsKeys } from '../../cache-keys/bucketsKeys';

export function useApplicationBucket(
  id: string,
  options?: { enabled?: boolean },
) {
  const api = useAPI();

  return useQuery({
    queryKey: [bucketsKeys.applicationBucket(id)],
    queryFn: queryFunction(
      ace_api.getApplicationBucket(api),
      ({ queryKey: [{ id }] }) => ({ id }),
    ),
    enabled: id !== '' && api.token !== '' && (options?.enabled ?? true),
  });
}
